import { CustomElement, resolve } from 'aurelia';
import { AdminService } from '../../services';
import template from './login-modal.html';

// Admin sign-in modal. Renders only while AdminService.showLogin is set. Reuses the shared
// modal shell styles (.modal-overlay/.login-*) from the global stylesheet. All state and the
// submit/cancel behavior live in AdminService.
export class LoginModalElement {
  readonly admin: AdminService = resolve(AdminService);
}

export const LoginModal = CustomElement.define({
  name: 'login-modal',
  template
}, LoginModalElement);
